import { Page } from './page';

export class PagerInfo {
    totalItems: number;
    currentPage: number;
    pageSize: number;
    totalPages: number;
    startIndex: number;
    endIndex: number;
    pages: Page[];

    get nextPageNumber() {
        return (this.currentPage < this.totalPages) ? this.currentPage + 1 : this.totalPages;
    }
    get previousPageNumber() {
        return (this.currentPage > 1) ? this.currentPage - 1 : 1;
    }


    constructor() {
        this.totalItems = 0;
        this.currentPage = 0;
        this.pageSize = 0;
        this.totalPages = 0;
        this.startIndex = 0;
        this.endIndex = 0;
        this.pages = new Array<Page>();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/pager-info.ts